<template>
  <button type="button" class="ui-icon-btn" :class="[size === 'sm' && 'ui-icon-btn--sm', plain && 'ui-icon-btn--plain']" :title="title || label" :aria-label="label" v-on="$listeners">
    <v-icon :size="iconSize">{{ icon }}</v-icon>
  </button>
</template>

<script>
/**
 * Okruglo dugme samo sa ikonom. size: md (40 px) | sm (34 px); plain je bez okvira (radnja u redu). `label` je naziv za čitače ekrana,
 * a `title` (zadano isti) podsjetnik pri zadržavanju miša.
 */
export default {
  name: "UiIconButton",
  props: {
    icon: { type: String, required: true },
    label: { type: String, required: true },
    title: { type: String, default: "" },
    size: { type: String, default: "md" },
    plain: { type: Boolean, default: false },
    iconSize: { type: Number, default: 18 },
  },
};
</script>
